import axios from "axios";
import BASE_URL from "../../assets/global/url";

// Accounts (account_list_sub3) under a base subject, e.g. Cash -> Cash on Hand
export const getSubject3 = async (subjectId) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/accountListSub/getSubject3`,
      { params: { subjectId } },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
